import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { wipQueryKey } from "./account.keys";

export const useFetchAccountWorkInProgressStatements = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: wipQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.WipStatement.List.Response>(
				`/v2/surety/accounts/${accountId}/work-in-progress-statements`,
			),
	});

	return {
		wipStatements: data,
		wipStatementsError: error,
		wipStatementsIsLoading: isLoading,
		refetchWipStatements: refetch,
	};
};
